export function enumKeys<O extends object, K extends keyof O = keyof O>(
	obj: O
): K[] {
	return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}
export function enumValues<O extends object>(obj: O): O[keyof O][] {
	return enumKeys<O>(obj).map((key: keyof O): O[keyof O] => obj[key]);
}
